import { render, staticRenderFns } from "./AdminKennelSearchDialogOld.vue?vue&type=template&id=82f0cfb2"
import script from "./AdminKennelSearchDialogOld.vue?vue&type=script&lang=ts"
export * from "./AdminKennelSearchDialogOld.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports